export default __webpack_public_path__ + "static/media/turbine_closed.735003d7.png";